export default __webpack_public_path__ + "static/cap2-f22ac580c5fd774cfa53188f23dbece5.mp4";